import { ClickableTile } from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import './TileOption.scss';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import messages from '../../../locales/messages';
import { convertToString } from '../../../lib/utils';

type TileOptionProps = {
  id: string;
  className: string;
  titleText: string;
  bodyText: string;
  icon: string;
  iconId: string;
  handleLaunchModal: (param: string) => void;
  optionNumber: number;
  setSelected: React.Dispatch<React.SetStateAction<number>>;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setPathSelected: React.Dispatch<React.SetStateAction<string>>;
};

export const TileOption = ({
  id,
  className,
  titleText,
  bodyText,
  handleLaunchModal,
  icon,
  iconId,
  optionNumber,
  setSelected,
  step,
  setStep,
  setPathSelected,
}: TileOptionProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <ClickableTile
        id={id}
        className={`tile ${className}`}
        role="button"
        onClick={() => {
          setPathSelected(convertToString(useTranslation(titleText, true)));
          handleLaunchModal(convertToString(useTranslation(titleText, true)));
          setSelected(optionNumber);
          setStep(step);
        }}
      >
        <PublicImage
          imgPath={icon}
          widgetId="ai-solutions-advisor"
          id={iconId}
          alt="AI Solutions Advisor icon picture"
          className="tileIcon"
        />
        <p className="tileTitle">{useTranslation(titleText)}</p>
        <p className="tileBody">{useTranslation(bodyText)}</p>
      </ClickableTile>
    </>
  );
};
